import { render } from "./WorkflowSettingsTemplateAi.vue?vue&type=template&id=74f1d8e8&scoped=true"
import script from "./WorkflowSettingsTemplateAi.vue?vue&type=script&lang=js"
export * from "./WorkflowSettingsTemplateAi.vue?vue&type=script&lang=js"

import "./WorkflowSettingsTemplateAi.vue?vue&type=style&index=0&id=74f1d8e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f1d8e8"]])

export default __exports__